/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleStateTransitionMetadataAnyOf } from './moduleStateTransitionMetadataAnyOf';

export type ModuleStateTransitionMetadata = ModuleStateTransitionMetadataAnyOf | null;
